import { DrawerToggleButton } from "@react-navigation/drawer";
import Drawer from "expo-router/drawer";
import { View, Text, Image, StyleSheet, Linking } from "react-native";
import colors from '@/constants/Colors';
import { GestureHandlerRootView } from 'react-native-gesture-handler';
import { Button } from "@/components/ui";

export default function Uniform() {
  const handleEmailPress = () => {
    Linking.openURL('mailto:shopify@crewsaders.com');
  };

  const gotoShopify = () => {
    Linking.openURL('https://merch.crewsaders.com/discount/0f9caa41-670e-4fae-bd3c-c5d036769374');
  };

  return (
    <GestureHandlerRootView style={{ flex: 1 }}>
      <Drawer.Screen
        options={{
          drawerLabel: 'Uniform',
          title: 'Uniform',
          headerStyle: {
            backgroundColor: colors.primary,
          },
          headerTintColor: colors.accent,
          headerLeft: () => <DrawerToggleButton tintColor={colors.accent} />
        }}
      />
      <View style={styles.container}>
        <Image
          source={require("@/assets/images/shopfront.png")}
          style={styles.logo}
        />
        <View style={styles.messageContainer}>
          <Text style={styles.title}>Order your uniform.</Text>

          <Button
            variant="crew"
            onPress={gotoShopify}
          >
            Visit the Uniform Shop
          </Button>
          <Text style={[styles.paragraph]} >
            All Uniform orders are zero cost at the point of checkout and will be deducted from your next months pay as per your Crewsaders contract terms and conditions.
          </Text>
          <Text style={[styles.paragraph]}>
            Merch orders are charged at checkout.
          </Text>

          <Button
            variant="crew"
            size="sm"
            onPress={handleEmailPress}
          >Contact the Uniform Team</Button>
        </View>
      </View>
    </GestureHandlerRootView>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: colors.background,
    justifyContent: 'flex-start',
    alignItems: 'center',
    padding: 0,
  },
  logo: {
    width: '100%',
    height: 285,
    marginBottom: 0,
    opacity: 0.9,
  },
  messageContainer: {
    flex: 1,
    alignItems: 'center',
    width: '100%',
    justifyContent: 'space-evenly',
    paddingHorizontal: 20,
    paddingVertical: 20,
  },
  title: {
    fontSize: 22,
    fontWeight: 'bold',
    marginBottom: 16,
    textAlign: 'center',
  },
  paragraph: {
    fontSize: 16,
    textAlign: 'center',
    marginBottom: 12,
    lineHeight: 24,
  },
  text: {
    fontSize: 16,
    textAlign: 'center',
    lineHeight: 24,
  },
  emailLink: {
    color: 'blue',
    textDecorationLine: 'underline',
    fontSize: 16,
    marginVertical: 8,
    fontWeight: '500',
  },
});